var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLifeInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19c2.06-3.128 5.563-4.697 9-4.564m3.75-8.273c0 2.3-1.903 4.164-4.25 4.164S5.25 8.463 5.25 6.164C5.25 3.864 7.153 2 9.5 2s4.25 1.864 4.25 4.163zM16 16.5l1.2 1 1.8-2",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.443 11c-2.046 1.121-3.323 1.554-5.442 1.6-.04 5.423 1.289 7.695 5.442 10.4 4.236-2.489 5.365-4.832 5.557-10.4-2.381-.075-3.601-.44-5.557-1.6z",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconLifeInsurance;